(function () {
  'use strict';

  function getVariantId(card) {
    var sel = card.querySelector('[data-cave-variant]');
    if (sel) return sel.value || null;
    var hidden = card.querySelector('[data-cave-vid]');
    return hidden ? hidden.dataset.caveVid : null;
  }

  function showErr(card) {
    var err = card.querySelector('[data-cave-err]');
    if (!err) return;
    err.hidden = false;
    setTimeout(function () { err.hidden = true; }, 2800);
  }

  function showFeedback(btn, msg) {
    var orig = btn.textContent;
    btn.textContent = msg;
    btn.disabled = true;
    setTimeout(function () {
      btn.textContent = orig;
      btn.disabled = false;
    }, 2200);
  }

  function updateCartCount(count) {
    document.querySelectorAll(
      '[data-cart-count], .cart-count, .js-cart-count, [data-header-cart-quantity]'
    ).forEach(function (el) { el.textContent = count; });
  }

  // ── Sync: hide in-cart cards, collapse empty sections ──
  function caveSync() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = {};
        cart.items.forEach(function (item) { inCart[item.product_id] = true; });
        updateCartCount(cart.item_count);

        document.querySelectorAll('[data-cave-pid]').forEach(function (card) {
          var pid = parseInt(card.dataset.cavePid, 10);
          if (inCart[pid]) {
            card.setAttribute('data-hidden', '');
          } else {
            card.removeAttribute('data-hidden');
          }
        });

        document.querySelectorAll('[data-cave-section]').forEach(function (sec) {
          var wrapper = sec.closest(
            '.cave-upsell-section, .cave-product-upsell, .cave-popup__cards'
          );
          var target = wrapper || sec;
          var visible = sec.querySelectorAll('[data-cave-pid]:not([data-hidden])').length;
          if (visible === 0) {
            target.setAttribute('data-empty', '');
          } else {
            target.removeAttribute('data-empty');
          }
        });

        syncPopup();
      })
      .catch(function () {});
  }

  // ── Cart upsell refresh via Section Rendering API ──
  var _cartRefreshTimer = null;
  function refreshCartUpsell() {
    var mount = document.getElementById('cave-cart-upsell-mount');
    if (!mount) return;
    fetch('/?sections=cave-cart-upsell')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cave-cart-upsell'];
        if (html) {
          mount.innerHTML = html;
          setTimeout(caveSync, 100);
        }
      })
      .catch(function () {});
  }
  function scheduleCartRefresh() {
    clearTimeout(_cartRefreshTimer);
    _cartRefreshTimer = setTimeout(refreshCartUpsell, 1000);
  }

  // ── AJAX add to cart ──
  // Each in-flight add is tracked in _activeAdds so the pre-checkout popup's
  // "Continue to Checkout" can wait for a pending add to finish before it
  // redirects — otherwise a just-added gift/perfume could be lost.
  var _activeAdds = [];
  function addToCart(vid, onSuccess, onError) {
    var p = fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (item && item.id) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } }));
          document.dispatchEvent(new CustomEvent('cart:build'));
          if (onSuccess) onSuccess();
        } else {
          if (onError) onError();
        }
      })
      .catch(function () { if (onError) onError(); });

    _activeAdds.push(p);
    var cleanup = function () {
      var i = _activeAdds.indexOf(p);
      if (i > -1) _activeAdds.splice(i, 1);
    };
    p.then(cleanup, cleanup);
    return p;
  }

  // ── Add button click ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cave-add]');
    if (!btn) return;
    e.preventDefault();

    var card = btn.closest('[data-cave-pid]');
    if (!card) return;

    var vid = getVariantId(card);
    if (!vid) {
      showErr(card);
      var sel = card.querySelector('[data-cave-variant]');
      if (sel) {
        sel.style.borderColor = '#c0392b';
        setTimeout(function () { sel.style.borderColor = ''; }, 2000);
      }
      return;
    }

    btn.disabled = true;
    btn.textContent = '…';
    addToCart(vid,
      function () { showFeedback(btn, 'Added ✓'); },
      function () { showFeedback(btn, 'Error'); }
    );
  });

  // Clear error on select change
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cave-variant]')) return;
    var card = e.target.closest('[data-cave-pid]');
    if (!card) return;
    e.target.style.borderColor = '';
    var err = card.querySelector('[data-cave-err]');
    if (err) err.hidden = true;
  });

  // ============================================================
  //  GET THE LOOK TRIGGER
  // ============================================================

  function initGetTheLookTrigger() {
    var trigger = document.getElementById('cave-gtl-trigger');
    if (!trigger) return;

    function isMobile() { return window.innerWidth < 769; }

    function openDrawer() {
      var drawer = document.getElementById('cave-gtl-drawer');
      var content = document.getElementById('cave-gtl-drawer-content');
      var source = document.querySelector('.cave-product-upsell');
      if (!drawer || !content) return;
      content.innerHTML = '';
      if (source) {
        var clone = source.cloneNode(true);
        clone.removeAttribute('id');
        clone.removeAttribute('data-empty');
        clone.style.removeProperty('display');
        content.appendChild(clone);
      }
      drawer.removeAttribute('hidden');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cave-drawer-open');
      setTimeout(caveSync, 50);
    }

    function closeDrawer() {
      var drawer = document.getElementById('cave-gtl-drawer');
      if (!drawer) return;
      drawer.setAttribute('hidden', '');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cave-drawer-open');
    }

    trigger.addEventListener('click', function () {
      if (isMobile()) {
        var target = document.getElementById('cave-product-upsell');
        if (target) {
          var offset = target.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: offset, behavior: 'smooth' });
        }
      } else {
        openDrawer();
      }
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); trigger.click(); }
    });

    var closeBtn = document.getElementById('cave-gtl-drawer-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    var overlay = document.getElementById('cave-gtl-drawer-overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      var drawer = document.getElementById('cave-gtl-drawer');
      if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
    });
  }

  // ============================================================
  //  PRE-CHECKOUT POPUP
  // ============================================================

  var popup = null;
  var popupShownKey = 'cave_popup_shown_v1';
  // Where "Continue to Checkout" sends the customer. Always the real Shopify
  // checkout — never the cart form action (which is /cart and caused the bug).
  var CHECKOUT_URL = '/checkout';
  var pendingCheckoutUrl = CHECKOUT_URL;
  var _redirecting = false;

  function syncPopup() {
    if (!popup) return;
    var cardsContainer = popup.querySelector('.cave-popup__cards');
    if (!cardsContainer) return;
    var visible = cardsContainer.querySelectorAll('[data-cave-pid]:not([data-hidden])').length;
    if (visible === 0) {
      cardsContainer.setAttribute('data-empty', '');
    } else {
      cardsContainer.removeAttribute('data-empty');
    }
  }

  function popupHasProducts() {
    if (!popup) return false;
    var sec = popup.querySelector('[data-cave-section]');
    if (!sec) return false;
    return sec.querySelectorAll('[data-cave-pid]:not([data-hidden])').length > 0;
  }

  function openPopup(checkoutUrl) {
    if (!popup) return false;
    if (!popupHasProducts()) return false;
    if (sessionStorage.getItem(popupShownKey)) return false;
    pendingCheckoutUrl = checkoutUrl || CHECKOUT_URL;
    popup.removeAttribute('hidden');
    var modal = popup.querySelector('.cave-popup__modal');
    if (modal) modal.focus();
    sessionStorage.setItem(popupShownKey, '1');
    return true;
  }

  function closePopup() {
    if (!popup) return;
    popup.setAttribute('hidden', '');
  }

  // Redirect straight to Shopify checkout. If a gift/perfume add is still in
  // flight, wait for it to finish first so the item is not lost — with a
  // generous fallback so a hung request can never strand the customer.
  function proceedToCheckout(btn) {
    if (_redirecting) return;
    _redirecting = true;
    var target = CHECKOUT_URL;
    if (btn) { btn.disabled = true; btn.textContent = 'Redirecting…'; }
    var go = function () { window.location.href = target; };
    if (_activeAdds.length) {
      Promise.all(_activeAdds.map(function (p) { return p.catch(function () {}); })).then(go);
      setTimeout(go, 4000);
    } else {
      go();
    }
  }

  function initPopup() {
    popup = document.getElementById('cave-checkout-popup');
    if (!popup) return;

    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-cave-popup-close]')) {
        closePopup();
        return;
      }
      var contBtn = e.target.closest('[data-cave-popup-checkout]');
      if (contBtn) {
        e.preventDefault();
        e.stopPropagation();
        closePopup();
        proceedToCheckout(contBtn);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup && !popup.hidden) closePopup();
    });

    syncPopup();
  }

  function initCheckoutIntercept() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href="/checkout"], .cart__checkout-btn'
      );
      if (!btn) return;
      // Never touch accelerated / dynamic checkout buttons.
      if (btn.closest(
        '.shopify-payment-button, [data-shopify="payment-button"], .dynamic-checkout, .dynamic-checkout__content'
      )) return;
      if (popup && !popup.hidden) return;
      // Always continue to the real Shopify checkout — NOT the cart form action.
      if (openPopup(CHECKOUT_URL)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  }

  function init() {
    caveSync();
    initPopup();
    initCheckoutIntercept();
    initGetTheLookTrigger();

    document.addEventListener('ajaxProduct:added', scheduleCartRefresh);
    document.addEventListener('cart:build', scheduleCartRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
